const asId = (value) => {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0
    ? id
    : null;
};

export const getPairKey = (tagId, eventTemplateId) => {
  const horseId = asId(tagId);
  const templateId = asId(eventTemplateId);
  return horseId && templateId
    ? `${horseId}:${templateId}`
    : null;
};

export const getReminderPairKey = (reminder) => {
  const definition = reminder?.eventTemplateReminder;
  if (reminder?.archived || reminder?.tag?.archived || definition?.archived || definition?.eventTemplate?.archived) return null;
  return getPairKey(reminder?.tag?.id, definition?.eventTemplate?.id);
};

